var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('r-button',_vm._g({attrs:{"icon":"close","unelevated":"","round":""}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }